
var isTouchDevice = "ontouchstart" in document.documentElement; 

if (!isTouchDevice) {
  const cursor = document.createElement("div");
  const inner = document.createElement("div");
  cursor.classList.add("cheeky-cursor", "out");
  inner.classList.add("cheeky-cursor__inner");
  cursor.appendChild(inner);
  document.body.appendChild(cursor);

  // Gets the mouse position
  const getMousePos = (e) => ({
    x: e.clientX,
    y: e.clientY,
  });

  // Track the mouse position
  let mouse = { x: 0, y: 0 };

  window.addEventListener("mousemove", (ev) => {
    mouse = getMousePos(ev);

    cursor.classList.remove("out");
    cursor.style.transform = `translate3d(${mouse.x}px, ${mouse.y}px, 0px)`;
  });

  window.addEventListener("mouseout", (ev) => {
    cursor.classList.add("out");
  });

  [
    {
      selector: ".image-banner",
      className: "over-large",
    },
    {
      selector: "a",
      className: "over-xsmall",
    },
    {
      selector: "img",
      className: "over-medium",
    },
    {
      selector: ".background",
      className: "over-medium",
    },
    {
      selector: "[href='/pages/about-us'].large-block",
      className: "over-large",
    },
  ].forEach((el) => {
    [...document.querySelectorAll(el.selector)].forEach((e) => {
      
      e.addEventListener("mouseenter", (ev) => {
        // ev.stopPropagation();
        
        if (!cursor.classList.contains(el.className)) {
          cursor.classList.add(el.className);
        }
      });

      e.addEventListener("mouseleave", (ev) => {
        // ev.stopPropagation();
        cursor.classList.remove(el.className);
      });
    });
  });
}